import { Injectable } from '@angular/core';
import { toast } from '@spartan-ng/brain/sonner';

@Injectable({ providedIn: 'root' })
export class UiFeedbackService {
  toast(message: string, durationMs = 3200): void {
    toast(message, { duration: durationMs });
  }
}
